/**
 * Shared HTTP-error-to-toast-message mapping.
 * 401 is intentionally not handled here — the global axios interceptor
 * (api/axios.js) already clears the token and redirects to /login on any 401.
 *
 * `overrides` lets a call site keep a more specific, action-appropriate
 * message for a given status code (e.g. { 409: "Trip is already started or
 * completed." }) while still sharing the rest of the mapping.
 */
export function extractErrorMessage(err, fallback, overrides = {}) {
  const data = err?.response?.data;
  if (data?.message) {
    return typeof data.details === "string" && data.details
      ? `${data.message}. ${data.details}`
      : data.message;
  }

  // The request went out but no response came back (offline, server down, CORS).
  if (err?.request && !err?.response) {
    return "Could not reach the server. Check your internet connection and try again.";
  }

  const status = err?.response?.status;
  if (status != null && overrides[status]) return overrides[status];
  // Some endpoints (e.g. /location) answer { error: "<sentence>" }; skip bare codes.
  if (typeof data?.error === "string" && /\s/.test(data.error.trim())) return data.error;
  if (status === 403) return "You don't have permission for this action.";
  if (status === 404) return "Not found. Please refresh and try again.";
  if (status === 409) return "This conflicts with the current state. Please refresh and try again.";
  if (status >= 500) return "Server error. Please try again later.";
  return fallback;
}

export const TOAST_OK = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const TOAST_ERR = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};
